import { store } from 'Models/Store';

/**
 * True when the given minimum-width id forces a wider-than-standard width — i.e. its capacity
 * multiplier is above the base width's. Used to decide whether a vehicle/trailer type *requires*
 * a non-standard width (so the width checkbox must stay ticked).
 */
export function widthRequiresNonBase(minimumWidthId?: string): boolean {
	if (!minimumWidthId) {
		return false;
	}
	const baseWidth = store.widths.find(w => w.isBase);
	const minimumWidth = store.widths.find(w => w.id === minimumWidthId);
	if (!baseWidth || !minimumWidth) {
		return false;
	}
	return minimumWidth.capacityMultiplier > baseWidth.capacityMultiplier;
}

/**
 * Capacity multiplier for a width id, falling back to the base width's multiplier (or 1) when the
 * id is missing/unknown. Used to compare widths when deciding which is wider.
 */
export function getWidthCapacityMultiplier(widthId?: string): number {
	const width = store.widths.find(w => w.id === widthId);
	if (width) {
		return width.capacityMultiplier;
	}
	return store.widths.find(w => w.isBase)?.capacityMultiplier ?? 1;
}
